// Dependencies
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Power0, Power4 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import $ from 'jquery'
import TransitionGroup from 'react-transition-group/TransitionGroup'

// Components
import HorizontalMenu from 'components/HorizontalMenu'
import EntryListItem from 'components/EntryListItem'
// import NewsLine from 'components/NewsLine'

// Styles
import './index.scss'

class EntryList extends Component {
  componentWillEnter (callback) {
    const $el = $(this.container)
    const timeline = new TimelineMax({ delay: 1, onComplete: callback })

    timeline
      .staggerFromTo(
        $el.find('.entry-item__details'),
        0.6,
        { opacity: '0' },
        { opacity: '1', ease: Power0.easeNone },
        0.2,
        0.3
      )
      .staggerFromTo(
        $el.find('.horizontal-menu > li'),
        0.3,
        { y: '-20px', opacity: '0' },
        { y: '0px', opacity: '1', ease: Power4.easeOut },
        0.05,
        0
      )
      .staggerFromTo(
        $el.find('.entry-item__image div'),
        0.3,
        { x: '-100%' },
        { x: '0%', ease: Power4.easeNone },
        0.2,
        0
      )
      .staggerFromTo(
        $el.find('.entry-item__image img'),
        0.3,
        { x: '100%' },
        { x: '0%', ease: Power4.easeNone },
        0.2,
        0
      )
  }

  componentWillLeave (callback) {
    const $el = $(this.container)
    const timeline = new TimelineMax({ onComplete: callback })
    $el.find('.entry-item__image').removeClass('allow-hover')

    timeline
      .to($el.find('.news-line'), 1, { y: '-100%', ease: Power4.easeOut }, 0)
      .staggerTo(
        $el.find('.entry-item__details'),
        0.3,
        { opacity: '0', ease: Power0.easeNone },
        0.2,
        0
      )
      .staggerTo(
        $el.find('.horizontal-menu > li'),
        0.3,
        { y: '-20px', opacity: '0', ease: Power4.easeOut },
        0.05,
        0
      )
      .staggerTo(
        $el.find('.entry-item__image div'),
        0.3,
        { x: '100%', ease: Power4.easeNone },
        0.2,
        0.3
      )
      .staggerTo(
        $el.find('.entry-item__image img'),
        0.3,
        { x: '-100%', ease: Power4.easeNone },
        0.2,
        0.3
      )
  }

  renderItems (items) {
    if (!items) {
      return null
    }

    return (
      items.map((item) => {
        return <EntryListItem key={item.id} item={item} />
      })
    )
  }

  render () {
    let items = this.props.items

    let categories

    if (items.length > 0) {
      categories = this.props.categories.reduce((prevVal, category, index) => {
        if (category.name !== 'Uncategorized' && category.count !== 0) {
          prevVal.push({
            id: category.id,
            link: category.link,
            name: category.name
          })
        }
        return prevVal
      }, [{ id: 0, link: '/news/', name: 'All' }])
    } else {
      categories = null
    }

    return (
      <div ref={el => { this.container = el; return false }}>
        <HorizontalMenu items={categories} />
        <ul className='items-list'>{this.renderItems(items)}</ul>
      </div>
    )
  }
}

EntryList.propTypes = {
  categories: PropTypes.array,
  items: PropTypes.array
}

export default EntryList



// WEBPACK FOOTER //
// ./src/components/EntryList/index.js